import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleShopNow = () => {
    navigate('/products');
  };

  return (
    <div className="not-found">
      <div className="not-found__container">
        {/* Animated Background Elements */}
        <div className="not-found__bg-decoration">
          <div className="not-found__circle not-found__circle--1"></div>
          <div className="not-found__circle not-found__circle--2"></div>
          <div className="not-found__circle not-found__circle--3"></div>
        </div>

        {/* 404 Number */}
        <div className="not-found__number">
          <span className="not-found__digit">4</span>
          <span className="not-found__digit not-found__digit--zero">
            <svg viewBox="0 0 200 200" className="not-found__zero-icon">
              <circle cx="100" cy="100" r="80" fill="none" stroke="currentColor" strokeWidth="8"/>
              <path d="M60 80 L140 120 M140 80 L60 120" stroke="currentColor" strokeWidth="8" strokeLinecap="round"/>
            </svg>
          </span>
          <span className="not-found__digit">4</span>
        </div>

        {/* Content */}
        <div className="not-found__content">
          <h1 className="not-found__title">Page Introuvable</h1>
          <p className="not-found__description">
            Oups ! La page que vous recherchez semble avoir été déplacée ou n'existe plus.
          </p>
          <p className="not-found__suggestion">
            Mais ne vous inquiétez pas, nous avons plein d'autres belles choses à vous montrer !
          </p>

          {/* Countdown */}
          <div className="not-found__countdown">
            <div className="not-found__countdown-circle">
              <svg className="not-found__countdown-svg" viewBox="0 0 100 100">
                <circle
                  className="not-found__countdown-bg"
                  cx="50"
                  cy="50"
                  r="45"
                />
                <circle
                  className="not-found__countdown-progress"
                  cx="50"
                  cy="50"
                  r="45"
                  style={{
                    strokeDashoffset: `${282.7 * (countdown / 10)}`
                  }}
                />
              </svg>
              <span className="not-found__countdown-number">{countdown}</span>
            </div>
            <p className="not-found__countdown-text">
              Redirection automatique vers l'accueil...
            </p>
          </div>

          {/* Action Buttons */}
          <div className="not-found__actions">
            <button 
              className="not-found__btn not-found__btn--primary"
              onClick={handleGoHome}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              Retour à l'accueil
            </button>

            <button 
              className="not-found__btn not-found__btn--secondary"
              onClick={handleGoBack}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="19" y1="12" x2="5" y2="12"/>
                <polyline points="12 19 5 12 12 5"/>
              </svg>
              Page précédente
            </button>

            <button 
              className="not-found__btn not-found__btn--outline"
              onClick={handleShopNow}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="9" cy="21" r="1"/>
                <circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
              </svg>
              Découvrir nos produits
            </button>
          </div>

          {/* Quick Links */}
          <div className="not-found__links">
            <p className="not-found__links-title">Pages populaires :</p>
            <div className="not-found__links-grid">
              <a href="/products" className="not-found__link">
                Nos Produits
              </a>
              <a href="/about" className="not-found__link">
                À Propos
              </a>
              <a href="/contact" className="not-found__link">
                Contact
              </a>
              <a href="/" className="not-found__link">
                Accueil
              </a>
            </div>
          </div>
        </div>

        {/* Decorative Furniture Icons */}
        <div className="not-found__decorations">
          <div className="not-found__decoration not-found__decoration--1">
            <svg viewBox="0 0 100 100" fill="currentColor">
              <rect x="20" y="60" width="60" height="8" rx="2"/>
              <rect x="25" y="35" width="50" height="30" rx="2"/>
              <rect x="15" y="68" width="8" height="25" rx="2"/>
              <rect x="77" y="68" width="8" height="25" rx="2"/>
            </svg>
          </div>
          <div className="not-found__decoration not-found__decoration--2">
            <svg viewBox="0 0 100 100" fill="currentColor">
              <circle cx="50" cy="35" r="15"/>
              <rect x="42" y="50" width="16" height="40" rx="2"/>
              <path d="M35 60 L25 80 L35 82 L40 65 Z"/>
              <path d="M65 60 L75 80 L65 82 L60 65 Z"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;